import type { createBrowserRouter } from "react-router";

/** The data router instance, set by main.tsx. React Router's `useNavigate()` inside the app's own <Routes> (descendants of the one
 *  data route) forwards only `state` to the router and drops `viewTransition`, so the phone's slides (lib/nav.ts) go through the
 *  instance directly. */
type AppRouter = ReturnType<typeof createBrowserRouter>;
let router: AppRouter | null = null;
export const setRouter = (r: AppRouter) => { router = r; };
export const getRouter = () => router;
